import { flipRotateSlice } from "./flipRotateSlice";

export const {
    // image
    setImage,
    // flip
    flipToggleHorizontal,
    flipToggleVertical,
    flipReset,
    // rotate
    rotateSetStraighten,
    rotateSetRotation,
    rotateReset,
    setCurrentType,
    resetSettings,
    setIsLoading,
    setUploadData,
    restoreState,
} = flipRotateSlice.actions;
